import React, { useContext, useMemo } from 'react'

import { BlockContainer } from '@Components/BlockContainer'
import { SubscribeNewsletterForm } from '@Components/SubscribeNewsletterForm'
import { Block } from '@Generated/graphql'
import { BlockContext } from '@Globals/CMS/Context'
import { getJSONFieldValue, getRTEFieldValue } from '@Globals/CMS/FieldHelpers'

import styles from './SubscribeBlock.module.scss'

const SubscribeBlock = ({
  data,
  id,
}: {
  data: Block
  id?: string
}) => {
  const { presentation } = useContext(BlockContext)
  const blockData = useMemo(() => {
    const fields = data.fields || []

    if (data.type === 'notify_me_block') {
      return {
        campaignLabel: getJSONFieldValue<string>(fields, 'identifyingLabel') || '',
        submitText: getJSONFieldValue<string>(fields, 'submitButtonText') || '',
        thankYouText: getJSONFieldValue<string>(fields, 'thankYouText') || '',
      } as const
    }

    let legacyBackgroundColor: string | undefined
    if (parseInt(data.id || '0', 10) < 20 && !data?.appearance) {
      legacyBackgroundColor = 'var(--neutral-200)'
      if (getJSONFieldValue(fields, 'customBackgroundColor')) {
        legacyBackgroundColor = getJSONFieldValue<string>(fields, 'backgroundColor') || ''
      }
    }

    return {
      campaignLabel: `subscribe_block_${data.id}`,
      // TODO: can be removed when all blocks have appearance defined
      legacyBackgroundColor,
      // TODO: can be removed when all blocks have common defined
      legacyText: getRTEFieldValue(fields, 'description'),
      legacyTitle: getJSONFieldValue<string>(fields, 'headline')?.toString() || '',
      submitText: getJSONFieldValue<string>(fields, 'submitButtonText') || '',
      thankYouText: getRTEFieldValue(fields, 'subscribedText') || '',
    } as const
  }, [data])

  return (
    <BlockContainer
      appearance={{
        ...data.appearance,
        backgroundColor: data.appearance?.backgroundColor || blockData.legacyBackgroundColor,
      }}
      className={styles.block}
      common={{
        ...data.common,
        text: data.common?.text || blockData.legacyText,
        title: data.common?.title || blockData.legacyTitle,
      }}
      id={id}
      presentation={presentation}
    >
      <SubscribeNewsletterForm
        campaignLabel={blockData.campaignLabel}
        sourceID="cms_notify_me"
        submitText={blockData.submitText}
        thankYouText={blockData.thankYouText}
      />
    </BlockContainer>
  )
}

export default SubscribeBlock
